import { render } from "./CarouselTest.vue?vue&type=template&id=2c4c3d18"
import script from "./CarouselTest.vue?vue&type=script&lang=js"
export * from "./CarouselTest.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__